export type ContainsArchivedConversations = 'yes' | 'no' | 'restoring' | 'completed';
export enum ContainsArchivedConversationsEnum {
  YES = 'yes',
  NO = 'no',
  RESTORING = 'restoring',
  COMPLETED = 'completed'
}
